module.exports = __webpack_public_path__ + "static/floorplan6-a6f428bcfd0d3bc5ad45dc689cccc6a4.png";